import { render, staticRenderFns } from "./TextRows.vue?vue&type=template&id=eb27a0c8&"
import script from "./TextRows.vue?vue&type=script&lang=js&"
export * from "./TextRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports